import React, {useState, useEffect, useContext, useCallback, useRef} from 'react';
import GridLayout from 'react-grid-layout';
import './gridcomponents/css/StagnantInstrumentGrid.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import StagnantInstrumentRow from "./gridcomponents/StagnantInstrumentrow/StagnantInstrumentRow";
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';  // Import Search Icon
import {fetchStagnantInstruments} from './StagnantInstrumentService';
import ActionButtons from "./gridcomponents//components/ActionButtons";
import {useStateUpdatePermission} from "../contexts/StateUpdateContext";
import WebSocketService from "../../websockets/WebSocketService";
import {updateTickerSubscriptionWithKite} from "../services/apiService";
import {handleShowDetails} from "./gridcomponents/StagnantInstrumentrow/MoreDetails/MoreDetailsOperations";
import Stopcon from "./gridcomponents/components/Stopcon";
import {TickProvider} from "../contexts/TickContext";
import { InstrumentRowContext } from "@dashboard/contexts/InstrumentRowContext";
import MoreDetailsLayout from "../marketwatch/gridcomponents/guiinstrumentrow/MoreDetails/MoreDetailsLayout";
import {AnnouncementProvider} from "@dashboard/contexts/ExchangeAnnContext";
import {DataContext} from "@dashboard/contexts/DataContext";
import {RowSelectionProvider} from "@portfolio/context/RowSelectionContextProvider";
import {normalizeSymbol} from "@dashboard/shared/pfSymbolsRef";


const StagnantInstrumentsGrid = () => {
    const [StagnantInstruments, setStagnantInstruments] = useState([]);
    const [layouts, setLayouts] = useState([]);
    const {canUpdateState} = useStateUpdatePermission(); // Access state and setter
    const gridLayoutRef = useRef(null);
    const moreDetailsLayoutRef = useRef(null); // Define the ref in a React component
    const rowHeightGridLayout = 45;
    const [stagGrefreshKey, setStagGrefreshKey] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [isCircleGreen, setIsCircleGreen] = useState(true); // State to hold circle color
    const [pendingRefresh, setPendingRefresh] = useState(false); // Track if a refresh is pending
    const tabID=11;
    const [hasStagnantCompaniesLoaded, sethasStagnantCompaniesLoaded] = useState(false);  // New state to track if data is loaded
    const {initialSymbolToBSEAnnouncementsMap,initialSymbolToNSEAnnouncementsMap} = useContext(DataContext);
    const lastSelectedSymbolRef = useRef(null);

    // Function to update price difference for each instrument
    const handlePriceDifferenceUpdate = (instrumentToken, priceDifference) => {
        if (canUpdateState) {
            setStagnantInstruments((prevInstruments) =>
                prevInstruments.map(instrument => {
                    if (instrument.instrumentEntity.instrumentToken === instrumentToken) {
                        return {...instrument, priceDifferencePercentage: priceDifference};
                    }
                    return instrument;
                })
            );
        }
    }
    useEffect(() => {
        fetchStagnantInstruments().then(data => {
            console.log('In fetchStagnantInstruments');
            setStagnantInstruments(data);

            const initialLayouts = data.map((StagnantInstrument, index) => ({
                i: `${tabID}-${StagnantInstrument.instrumentEntity.instrumentToken}`,
                x: 0,
                y: index,  // Use index for the y value
                w: 12,
                h: 1,
            }));
            setLayouts(initialLayouts);
            const instrumentEntities = data.map(StagnantInstrument => StagnantInstrument.instrumentEntity);

            updateTickerSubscriptionWithKite(instrumentEntities, tabID)
                .then(response => {
                })
                .catch(error => {
                    console.error('Error in subscription with Kite:', error);
                });
        });
        sethasStagnantCompaniesLoaded(true);
    }, [stagGrefreshKey]);

    const isCircleGreenRef = useRef(isCircleGreen);
    useEffect(() => {
        const refreshStagnant_Grid = () => {
            console.log(`Received WebSocket message to refresh the grid`);

            // Check the current color of the circle using the ref
            if (isCircleGreenRef.current) {
                console.log(`Circle is green, refreshing the grid immediately`);
                setStagGrefreshKey(oldStagGrefreshKey => oldStagGrefreshKey + 1); // Refresh immediately
            } else {
                console.log(`Circle is red, waiting for it to turn green before refreshing`);
                setPendingRefresh(true); // Set refresh as pending until circle turns green
            }
        };

        // Subscribe to the WebSocket service only once
        WebSocketService.subscribe('reloadStagG', null, refreshStagnant_Grid);

        // Cleanup WebSocket subscription on component unmount
        return () => {
            //console.log(`Unsubscribing from WebSocket for reloadStagG`);
            WebSocketService.unsubscribe('reloadStagG', null, refreshStagnant_Grid);
        };
    }, []);  // Empty dependency array ensures subscription happens only once

    useEffect(() => {
        if (isCircleGreen && pendingRefresh) {
            console.log(`Circle turned green, performing pending grid refresh`);
            setStagGrefreshKey(oldStagGrefreshKey => oldStagGrefreshKey + 1); // Trigger the pending grid refresh
            setPendingRefresh(false); // Reset pending refresh state
        }
    }, [isCircleGreen, pendingRefresh]);
    // Function to toggle the circle color and update the ref
    const handleCircleToggle = () => {
        setIsCircleGreen(prevState => {
            const newState = !prevState;
            isCircleGreenRef.current = newState;  // Update the ref
            return newState;
        });
        console.log("Toggling color...");

    };
    useEffect(() => {
        // Update the ref whenever isCircleGreen changes
        isCircleGreenRef.current = isCircleGreen;
    }, [isCircleGreen]);
    useEffect(() => {
        //console.log("isCircleGreen: ", isCircleGreen);
    }, [isCircleGreen]);
    // Dynamically calculate rowHeight and total grid height
    const rowHeightNewGridLayout = 36; // Assume each row is 40px high

    if (!hasStagnantCompaniesLoaded) {
        return (
            <div className="pf-loading-wrapper">
                <div className="pf-spinner" />
                <div className="pf-loading-text">Loading Stagnant…</div>
            </div>
        );
    }
    return (
        <div className="grid-wrapper">
            <div className="grid-container">
                    <div className={'stagnant-grid-holder'} key={tabID}>
                        <div className="resizable-container">
                            <div className="overlaping-grid-container">
                                <div className="search-input-container">
                                    <div className="search-button-1">
                                        <Button
                                            variant="contained"
                                            color="default">
                                            <SearchIcon/>
                                        </Button>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder='Search trading token'
                                        value={searchQuery}
                                        onChange={(e) => {
                                            const query = e.target.value;
                                            /*console.log('setting SearchQuery to: ', query);*/
                                            //setSearchQuery(query);
                                        }}
                                        className="search-input-box"
                                    />
                                    <Stopcon
                                        fontSize="large"
                                        isGreen={isCircleGreen} // Pass the current circle color
                                        onClick={handleCircleToggle} // Pass the toggle handler
                                    />
                                </div>
                            </div>

                            {/* Old Grid Layout */}
                            <RowSelectionProvider
                                stocks={StagnantInstruments}
                                lastSelectedSymbolRef={lastSelectedSymbolRef}
                                rowHeightGridLayout={rowHeightGridLayout}
                            >
                            <div ref={gridLayoutRef} className="grid-layout-wrapper">
                                <GridLayout
                                    className="grid-layout"
                                    layout={layouts}  // Layout prop controlling item positions
                                    cols={1}
                                    rowHeight={rowHeightGridLayout}
                                    width="400"
                                    isResizable={false}
                                    isDraggable={true}
                                    margin={[0, 0]}
                                    containerPadding={[0, 0]}
                                    draggableCancel=".symbol_n_exchange, .actionsSS, .actionsSS *"
                                >
                                    {layouts
                                        .map((layout, index) => {
                                            const instrument = StagnantInstruments.find(
                                                (instrument) => `${tabID}-${instrument.instrumentEntity.instrumentToken}` === layout.i
                                            );
                                            return (
                                                <div
                                                    key={layout.i}
                                                    className="grid-item"
                                                >
                                                    {(() => {
                                                    })()}
                                                    {instrument ? (
                                                        <InstrumentRowContext.Provider
                                                            value={{
                                                                uniqueId: layout.i,
                                                                GUIInstrument: instrument,
                                                                stock: instrument,
                                                                setGUIInstruments: setStagnantInstruments,
                                                                setLayouts,
                                                                tabID,
                                                                layouts,
                                                                index,
                                                                layoutIndex: index,
                                                                ROW_HEIGHT: rowHeightGridLayout
                                                            }}
                                                        >
                                                            <AnnouncementProvider
                                                                symbol={instrument.instrumentEntity.tradingsymbol}
                                                                initialBSE={initialSymbolToBSEAnnouncementsMap[normalizeSymbol(instrument.instrumentEntity.tradingsymbol)] || []}
                                                                initialNSE={initialSymbolToNSEAnnouncementsMap[normalizeSymbol(instrument.instrumentEntity.tradingsymbol)] || []}
                                                            >
                                                        <StagnantInstrumentRow
                                                            StagnantInstrument={instrument}
                                                            uniqueId={layout.i}
                                                            onPriceDifferenceUpdate={handlePriceDifferenceUpdate} // Pass the callback
                                                            setLayouts={setLayouts}
                                                            layoutIndex={index}
                                                        />
                                                        </AnnouncementProvider>
                                                        </InstrumentRowContext.Provider>
                                                    ) : (
                                                        <div>No Instrument Found</div>
                                                    )}
                                                    <InstrumentRowContext.Provider
                                                        value={{
                                                            uniqueId: layout.i,
                                                            GUIInstrument: instrument,
                                                            stock: instrument,
                                                            setGUIInstruments: setStagnantInstruments,
                                                            setLayouts,
                                                            tabID,
                                                            layouts,
                                                            index,
                                                            layoutIndex: index,
                                                            ROW_HEIGHT: rowHeightGridLayout
                                                        }}
                                                    >
                                                        <TickProvider instrumentToken={instrument.instrumentEntity.instrumentToken}>
                                                            <AnnouncementProvider
                                                                symbol={instrument.instrumentEntity.tradingsymbol}
                                                                initialBSE={initialSymbolToBSEAnnouncementsMap[normalizeSymbol(instrument.instrumentEntity.tradingsymbol)] || []}
                                                                initialNSE={initialSymbolToNSEAnnouncementsMap[normalizeSymbol(instrument.instrumentEntity.tradingsymbol)] || []}
                                                            >
                                                                <ActionButtons
                                                                    instrumentToken={instrument.instrumentEntity.instrumentToken}
                                                                    StagnantInstrument={instrument}
                                                                    setStagnantInstruments={setStagnantInstruments}
                                                                    setLayouts={setLayouts}
                                                                    tabID={tabID}
                                                                    onShowDetails={() => handleShowDetails(instrument.instrumentEntity.instrumentToken, StagnantInstruments, setStagnantInstruments, setLayouts, tabID, index, moreDetailsLayoutRef)}
                                                                    layouts={layouts}
                                                                />
                                                            </AnnouncementProvider>
                                                        </TickProvider>
                                                    </InstrumentRowContext.Provider>
                                                </div>
                                            );
                                        })}
                                </GridLayout>
                            </div>
                            </RowSelectionProvider>
                        </div>
                    </div>

                </div>
            </div>
    );
};

export default StagnantInstrumentsGrid;
